import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { MfaScreen } from '../features/B1/mfa-screen';

const flag = z
  .union([z.literal(1), z.literal('1'), z.literal(true)])
  .transform(() => 1 as const)
  .optional()
  .catch(undefined);

const search = z.object({
  setup: flag,
  recovery: flag,
  next: z
    .union([z.string(), z.number()])
    .transform((v) => String(v))
    .optional()
    .catch(undefined),
});

/** Bare screen: TOTP verify (?recovery=1 for a recovery code) and first-time setup (?setup=1). */
export const Route = createFileRoute('/mfa')({
  validateSearch: (s: Record<string, unknown>) => search.parse(s),
  component: MfaRoute,
});

function MfaRoute() {
  const { setup, recovery, next } = Route.useSearch();
  return <MfaScreen setup={setup === 1} recovery={recovery === 1} next={next} />;
}
